import React, { useEffect, useState } from 'react';

interface TimerProps {
    startedAt: number | undefined | null;
    totalSeconds: number;
}

export const Timer: React.FC<TimerProps> = ({ startedAt, totalSeconds }) => {
    const [currentTime, setCurrentTime] = useState(Date.now() / 1000);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(Date.now() / 1000);
        }, 500);

        return () => clearInterval(timer);
    }, []);

    const remainingTime = (() => {
        if (!startedAt) {
            return totalSeconds;
        }

        const elapsed = Math.floor(currentTime - startedAt);
        return Math.max(0, totalSeconds - elapsed);
    })();

    return (
        <div className={`Timer ${remainingTime === 0 ? 'timeout' : remainingTime < totalSeconds * 0.1 ? 'warning' : ''}`}>
            {remainingTime === 0 ? (
                'Time Out'
            ) : (
                <>
                    {Math.floor(remainingTime / 60).toString().padStart(2, '0')}:
                    {(remainingTime % 60).toString().padStart(2, '0')}
                </>
            )}
        </div>
    );
};